import type { FunctionComponent } from 'react';

import nuc from '../../../../../../shared/utils/nuc';
import Badge from '../../../../generic/Badge/Badge';
import { icons } from '../../../../generic/Icon/icons';
import RouterLink from '../../../../generic/Link/RouterLink';
import Loader from '../../../../generic/Loader';

import { InfoCard } from './InfoCard';

import styles from './LabelsCard.module.less';

const EMPTY_LABELS: string[] = [];

type Props = {
  labels?: string[];
  projectLocator?: string;
  isLoading: boolean;
};

/**
 * Card on the project summary page that shows the labels assigned to the project.
 */
export const LabelsCard: FunctionComponent<Props> = ({ labels = EMPTY_LABELS, projectLocator, isLoading }) => (
  <InfoCard title="Labels" icon={icons.tags} count={isLoading ? undefined : labels.length}>
    {isLoading && <Loader />}
    {!isLoading && labels.length === 0 && (
      <span className={styles.empty}>
        This project has no labels. Go to{' '}
        {projectLocator ? (
          <RouterLink to={`/projects/${nuc(projectLocator)}/settings`}>settings</RouterLink>
        ) : (
          'settings'
        )}{' '}
        to add them.
      </span>
    )}
    {!isLoading && labels.length > 0 && (
      <div className={styles.labels}>
        {labels.map((label) => (
          <Badge key={label} color="white" icon={icons.folderO} size="micro">
            {label}
          </Badge>
        ))}
      </div>
    )}
  </InfoCard>
);
